module.exports = __webpack_public_path__ + "img/inbox.8be37c36.png";